import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getFamily } from '../api/family';

const FamilyContext = createContext(null);

export function FamilyProvider({ children }) {
  const [family, setFamily] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFamily();
      setFamily(data);
    } catch (e) {
      const status = e.response?.status;
      if (status === 404 || status === 401 || status === 403) {
        setFamily(null);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <FamilyContext.Provider value={{ family, loading, refresh, setFamily }}>
      {children}
    </FamilyContext.Provider>
  );
}

export function useFamily() {
  return useContext(FamilyContext);
}
